/* File: financeWorkspace.js
 * Path: ananunadm/src/helpers/financeWorkspace.js
 *
 * The selected financial workspace is a per-browser preference sent as the
 * `x-finance-workspace` header. The API re-authorizes membership on every
 * request; the selection is never proof of access.
 */
export const FINANCE_WORKSPACE_STORAGE_KEY = "apit.finance.workspace";
export const FINANCE_WORKSPACE_HEADER = "x-finance-workspace";

export function getSelectedFinanceWorkspace() {
	try {
		return window.localStorage.getItem(FINANCE_WORKSPACE_STORAGE_KEY) || "";
	} catch (_) {
		return "";
	}
}

export function setSelectedFinanceWorkspace(id) {
	try {
		if (id) window.localStorage.setItem(FINANCE_WORKSPACE_STORAGE_KEY, String(id));
		else window.localStorage.removeItem(FINANCE_WORKSPACE_STORAGE_KEY);
	} catch (_) {
		// Private browsing: the server-side preference still applies.
	}
}

/** khnai.apit.am opens family/personal finances by default; the hostname is
 * only a default, not an authorization boundary. */
export function preferredWorkspaceType() {
	const host = typeof window !== "undefined" ? window.location.hostname : "";
	return /^khnai\./i.test(host) ? ["family", "personal"] : ["business"];
}

export function isFinanceApiRequest(url = "") {
	return /(^|\/)finance\//.test(String(url)) || /(^|\/)search\/global/.test(String(url));
}
